
<!-- <div *ngIf="loading" class="spinner-overlay-simple">
  <div class="spinner-simple"></div>
  <div class="spinner-text-simple">Carregando</div>
</div> -->
<div *ngIf="clienteValido" class="container">
  <h2>Ativação de Usuário</h2>
  <form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
    
    <div class="user-info">
      <p>Nome: {{nome}}<span id="username"></span></p>
      <p>Login: {{login}}<span id="loginMasked"></span></p>
    </div>

    <!-- Campo Email -->
    <div class="form-group">
      <label for="email">Confirmar E-mail</label>
      <input 
        class="form-control" 
        type="email" 
        id="email" 
        formControlName="email"
        [class.is-invalid]="(email?.touched || submitted) && email?.invalid"
      />
      <div *ngIf="(email?.touched || submitted) && email?.invalid" class="error text-danger">
        <span *ngIf="email?.errors?.['required']">O e-mail é obrigatório.</span>
        <span *ngIf="email?.errors?.['email']">E-mail inválido.</span>
      </div>
    </div>

    <!-- Campo Senha -->
    <div class="form-group">
      <label for="password">Senha</label>
      <input 
        class="form-control" 
        type="password" 
        id="password" 
        formControlName="password"
        [class.is-invalid]="(password?.touched || submitted) && password?.invalid"
      />
      <div *ngIf="(password?.touched || submitted) && password?.invalid" class="error text-danger">
        <span *ngIf="password?.errors?.['required']">A senha é obrigatória.</span>
        <span *ngIf="password?.errors?.['minlength']">Mínimo de 6 caracteres.</span>
      </div>
    </div>

    <!-- Campo Confirmar Senha -->
    <div class="form-group">
      <label for="confirmPassword">Confirmar Senha</label>
      <input 
        class="form-control" 
        type="password" 
        id="confirmPassword" 
        formControlName="confirmPassword"
        [class.is-invalid]="(confirmPassword?.touched || submitted) && (confirmPassword?.invalid || form.hasError('passwordMismatch'))"
      />
      <div *ngIf="(confirmPassword?.touched || submitted) && confirmPassword?.invalid" class="error text-danger">
        <span *ngIf="confirmPassword?.errors?.['required']">A confirmação de senha é obrigatória.</span>
        <span *ngIf="confirmPassword?.errors?.['minlength']">Mínimo de 6 caracteres.</span>
        <span *ngIf="form.hasError('passwordMismatch')">As senhas não conferem.</span>
      </div>
    </div>

    <!-- Termos LGPD -->
    <div class="form-group termos-lgpd-ativacao">
      <!-- <label>Utilizamos cookies para personalizar anúncios e melhorar sua experiência no site. Ao continuar navegando, você concorda com a nossa
        Política de Privacidade.</label> -->
        <a [href]="termsLink" target="_blank">Politicas de Privacidade</a>
      <!-- <div id="lgpd-box" class="border p-3 mb-2" style="max-height: 200px; overflow-y: auto;">
        <p>Coloque aqui o texto completo do termo LGPD que o usuário deve ler até o final.</p>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ullamcorper nec ex vel hendrerit. Donec vitae
          sapien vitae mauris semper tincidunt...</p>
      </div> -->

      <div style="margin-top: 10px; display: flex; align-items: center; gap: 8px;">
        <label class="switch" for="checkbox">
          <input type="checkbox" id="checkbox" formControlName="consent_lgpd" />
          <div class="slider round"></div>
        </label>
        <label>Confirmo que li e aceito os termos</label>
      </div>
      <div *ngIf="(consent_lgpd?.touched || submitted) && consent_lgpd?.invalid" class="error text-danger">
        <span *ngIf="consent_lgpd?.errors?.['required']">Você deve aceitar os termos para continuar.</span>
      </div>
    </div>

    <!-- Botão de Submit -->
    <button 
      type="submit" 
      class="btn btn-primary" 
      [disabled]="form.invalid"
    >
      Ativar Conta
    </button>
  </form>
</div>
<div *ngIf="!loading && !clienteValido">
  <div class="error-container text-center">
    <!-- Ícone de erro -->
    <div class="error-icon">
      <i class="fas fa-exclamation-triangle"></i>
    </div>
    
    <h2 class="text-danger">Link de Ativação Inválido</h2>
    
    <div class="error-message">
      <p>{{erroMsg}}</p>
      
  
    </div>

  </div>
</div>